import styled from 'styled-components';
import CardPay from '../../molecules/faculty/CardPay';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const CardsPay = (props) => {
    const { authorization, dollar, localCurrency, draftPay, type } = props;

    return (
        <>
            {type === 'table' ? (
                <CardsPayWrapper>
                    <CardPay
                        color={'#28A986'}
                        backgroundColor={'#EAFAF6'}
                        icon={CheckCircleOutlineIcon}
                        title="SOLICITUDES AUTORIZADAS"
                        data={authorization || 0}
                    />
                    <CardPay
                        color={'#D67539'}
                        backgroundColor={'#F2D3C0'}
                        icon={AccessTimeIcon}
                        title="SOLICITUDES NO AUTORIZADAS"
                        data={draftPay || 0}
                    />
                </CardsPayWrapper>
            ) : (
                <CardsPayWrapper>
                    <CardPay
                        color={'#CEB269'}
                        backgroundColor={'#F9F5EC'}
                        icon={AttachMoneyIcon}
                        title="DOLARES A COBRAR"
                        data={dollar || 0}
                        money={'USD'}
                    />
                    <CardPay
                        color={'#86A0E4'}
                        backgroundColor={'#E6EBF9'}
                        icon={AttachMoneyIcon}
                        title="MONEDA LOCAL A COBRAR"
                        data={`$${localCurrency || 0}`}
                    />
                </CardsPayWrapper>
            )}
        </>
    );
};

export default CardsPay;

const CardsPayWrapper = styled.div`
    width: calc(40% - 2rem);
    padding: 1rem;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background-color: #fff;
    box-shadow:
        0px 12px 24px -15px #0000001a,
        0px 0px 10px -6px #00000040;
    padding: 1rem;
    border-radius: 100px;

    @media (width < 1300px) {
        width: calc(70% - 2rem);
    }

    @media (width < 768px) {
        width: calc(100% - 2rem);
        background-color: transparent;
        box-shadow: none;
    }

    @media (width < 450px) {
        flex-direction: column;
    }
`;
